export class UtilsService {
  static generateUniqueId = (length: number = 6): string => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  };

  static isObjectEmpty = (object: object) => {
    return !Object.values(object).length;
  };

  static generatePassword(length: number = 12): string {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?";

    const cryptoRandom = new Uint32Array(length);
    crypto.getRandomValues(cryptoRandom);

    let password = "";
    for (let i = 0; i < length; i++) {
      password += characters[cryptoRandom[i] % characters.length];
    }

    return password;
  }
}
